export default "__VITE_ASSET__Ba_h26ai__"